module.exports = __webpack_public_path__ + "img/calculator.c3abb477.jpg";